import { TypedUseSelectorHook, useSelector as us } from "react-redux";
import { RootState } from "./store";

export const useSelector: TypedUseSelectorHook<RootState> = us;
